import { getCollapsiblePanelStyles, getStepStyles } from '../../shared/styles';

export const getStyles = (components, theme) => ({
  collapsiblePanel: getCollapsiblePanelStyles(components, theme),
  campaignSettingsStep: {
    ...getStepStyles(),

    '& .collapse-panel.disclaimer': {
      '& .collapse-content': {
        display: 'flex',
        flexDirection: 'column',
      },
    },
    '& .collapse-fixed-panel.website': {
      '& .collapse-title-bar': {
        paddingBottom: '5px',
      },
      '& .website-section': {
        '& input[type="text"]:focus': {
          border: 'none',
        },
        '& input[type="text"]:hover': {
          border: 'none',
        },
      },
    },
    '& .section-title': {
      marginTop: '28px',
      marginBottom: '8px',
    },
    '& .section-description': {
      marginBottom: '16px',
    },
  },
});
